import script from "./Sidentify.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidentify.vue?vue&type=script&setup=true&lang=js"

import "./Sidentify.vue?vue&type=style&index=0&id=9cb12440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cb12440"]])

export default __exports__